/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusRemoveObjektAnforderungenDto } from '../../models/lexplus-remove-objekt-anforderungen-dto';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface ObjekteControllerRemoveAnforderungenV1$Params {
  id: number;
      body: LexplusRemoveObjektAnforderungenDto
}

export function objekteControllerRemoveAnforderungenV1(http: HttpClient, rootUrl: string, params: ObjekteControllerRemoveAnforderungenV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, objekteControllerRemoveAnforderungenV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

objekteControllerRemoveAnforderungenV1.PATH = '/v1/objekte/{id}/anforderungen/remove';
